module.exports = __webpack_public_path__ + "img/AGR-B-1-II.d9aa580c.png";